import { weightedRoll, type RandomSource } from "@yjsgames/weighted-roll";
import type { HouseAdCampaign } from "./types.js";

/**
 * 활성 캠페인 중 weight에 비례해 1건 추첨한다 (순수, `@yjsgames/weighted-roll` 위임).
 * `enable=false` 또는 `weight<=0`인 캠페인은 후보에서 제외하며, 후보가 없으면 `null`을 반환한다.
 *
 * @param rng 0 이상 1 미만 난수 소스 (주입으로 테스트 결정론 확보).
 */
export function pickCampaign(
  rng: RandomSource,
  campaigns: readonly HouseAdCampaign[],
): HouseAdCampaign | null {
  const active = campaigns.filter((c) => c.enable && c.weight > 0);
  if (active.length === 0) return null;
  return weightedRoll(
    rng,
    active.map((c) => ({ value: c, weight: c.weight })),
    active[0]!,
  );
}
